<div class="receipt">
  @for (sectionData of _receiptArray; track sectionData) {
    <div [id]="sectionData?.sectionEvidenceID" class="app-receipt-section"
    [sectionData]="sectionData" (editRoute)="userEdit($event)" (noRoutingEditing)="handleNoRoutingEditing($event)"></div>
  }
</div>
<app-receipt-modal></app-receipt-modal>
